import React, { useState, useMemo, useContext } from 'react'
import ModalWindow from 'components/ModalWindow'
import { Button, Icon, Grid } from 'semantic-ui-react'
import { injectIntl } from 'react-intl'
import { UserContext, PdaContext } from 'context'

import ApplicationDetailsModal from './ApplicationDetailsModal'
import ApplicationCancelModal from './ApplicationCancelModal'
import ApplicationConfirmModal from './ApplicationConfirmModal'
import ApplicationApproveEditsModal from './ApplicationApproveEditsModal'
import ApplicationEditModal from './ApplicationEditModal'

const ApplicationActionsModal = (props) => {
  const { application, intl, options, onConfirmEditModal, reloadApp } = props
  const { currentUser } = useContext(UserContext)
  const { isPda } = useContext(PdaContext)
  const [open, setOpen] = useState(false)

  const translates = useMemo(() => ({
    confirm: intl.formatMessage({ id: 'btn.confirm' }),
    suggestChanges: intl.formatMessage({ id: 'btn.suggestChanges' }),
    actions: intl.formatMessage({ id: 'btn.actions' }),
    actionsModalTitle: intl.formatMessage({ id: 'title.actionsModalTitle' })
  }), [intl.locale]) // eslint-disable-line react-hooks/exhaustive-deps

  const openModal = () => {
    setOpen(true)
  }

  const closeModal = () => {
    setOpen(false)
  }

  const renderBtnsForCurrentUserRole = (role, statusId) => {
    switch (role) {
      case 0: {
        return (
          <>
            <Grid.Column>
              < ApplicationDetailsModal application={application} />
            </Grid.Column>
          </>
        )
      }
      case 2: {
        return (
          <>
            <Grid.Column>
              < ApplicationDetailsModal application={application} />
            </Grid.Column>
            {statusId === 1 && <Grid.Column><ApplicationConfirmModal reloadApp={reloadApp} application={application} action="confirm" closeParentModal={closeModal} /></Grid.Column>}
            {statusId !== 4 && statusId !== 6 && <Grid.Column><ApplicationCancelModal reloadApp={reloadApp} application={application} closeParentModal={closeModal} /></Grid.Column>}
            {statusId === 1 &&
              <Grid.Column>
                <ApplicationEditModal data={application} options={options} onConfirmEditModal={onConfirmEditModal} />
              </Grid.Column>
            }
          </>
        )
      }
      case 3: {
        return (
          <>
            <Grid.Column>
              < ApplicationDetailsModal application={application} />
            </Grid.Column>
            {statusId !== 2 && statusId !== 4 && statusId !== 6 && <Grid.Column><ApplicationConfirmModal reloadApp={reloadApp} application={application} action="cancel" closeParentModal={closeModal} /></Grid.Column>}
            {statusId === 2 && <Grid.Column><ApplicationApproveEditsModal reloadApp={reloadApp} application={application} closeParentModal={closeModal} /></Grid.Column>}
          </>
        )
      }
      default:
        return (
          <>
            <Grid.Column>
              < ApplicationDetailsModal application={application} />
            </Grid.Column>
          </>
        )
    }
  }

  return (
    <ModalWindow
      closeIcon
      iconType="info"
      title={translates.actionsModalTitle}
      open={open}
      onClose={() => closeModal()}
      onOpen={() => openModal()}
      trigger={
        <Button className="infoButton" icon><Icon name="info circle" /><span>{translates.actions}</span></Button>
      }
    >
      <div className="applicationActions">
        {isPda ?
          <Grid doubling stretched centered columns={4}>
            {renderBtnsForCurrentUserRole(currentUser.role, application.statusId)}
          </Grid>
          :
          <Grid doubling stretched centered columns={'equal'}>
            {renderBtnsForCurrentUserRole(currentUser.role, application.statusId)}
          </Grid>
        }
      </div>
    </ModalWindow>
  )
}

export default injectIntl(ApplicationActionsModal)